import React from 'react';
import { useNode } from '@craftjs/core';
import { Box } from '@mui/material';

export const ContainerSettings = () => {
  const {
    actions: { setProp },
    backgroundColor,
    padding,
    flexDirection,
    justifyContent,
    alignItems,
    gap,
  } = useNode((node) => ({
    backgroundColor: node.data.props.backgroundColor,
    padding: node.data.props.padding,
    flexDirection: node.data.props.flexDirection,
    justifyContent: node.data.props.justifyContent,
    alignItems: node.data.props.alignItems,
    gap: node.data.props.gap,
  }));

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ mb: 2 }}>
        <label>Цвет фона</label>
        <input
          type="color"
          value={backgroundColor === 'transparent' ? '#ffffff' : backgroundColor}
          onChange={(e) => setProp((props) => (props.backgroundColor = e.target.value))}
        />
        <button
          onClick={() => setProp((props) => (props.backgroundColor = 'transparent'))}
          style={{ marginLeft: '8px' }}
        >
          Прозрачный
        </button>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Отступы (px)</label>
        <input
          type="number"
          value={padding}
          onChange={(e) => setProp((props) => (props.padding = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        />
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Направление</label>
        <select
          value={flexDirection}
          onChange={(e) => setProp((props) => (props.flexDirection = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        >
          <option value="row">Горизонтально</option>
          <option value="column">Вертикально</option>
        </select>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Выравнивание (главная ось)</label>
        <select
          value={justifyContent}
          onChange={(e) => setProp((props) => (props.justifyContent = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        >
          <option value="flex-start">Начало</option>
          <option value="center">Центр</option>
          <option value="flex-end">Конец</option>
          <option value="space-between">По краям</option>
          <option value="space-around">Вокруг</option>
        </select>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Выравнивание (перпендикулярная ось)</label>
        <select
          value={alignItems}
          onChange={(e) => setProp((props) => (props.alignItems = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        >
          <option value="flex-start">Начало</option>
          <option value="center">Центр</option>
          <option value="flex-end">Конец</option>
          <option value="stretch">Растянуть</option>
        </select>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <label>Отступ между элементами (px)</label>
        <input
          type="number"
          value={gap}
          onChange={(e) => setProp((props) => (props.gap = e.target.value))}
          style={{ width: '100%', padding: '8px' }}
        />
      </Box>
    </Box>
  );
};

export const Container = ({ children, backgroundColor, padding, flexDirection, justifyContent, alignItems, gap }) => {
  const {
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    selected: state.events.selected,
  }));

  return (
    <Box
      ref={(ref) => connect(drag(ref))}
      sx={{
        backgroundColor,
        padding: `${padding}px`,
        display: 'flex',
        flexDirection,
        justifyContent,
        alignItems,
        gap: `${gap}px`,
        minHeight: '50px',
        border: selected ? '2px solid #00ACC1' : '2px dashed #e0e0e0',
        cursor: 'move',
        '&:hover': {
          border: '2px dashed #00ACC1',
        },
      }}
    >
      {children}
    </Box>
  );
};

Container.craft = {
  props: {
    backgroundColor: 'transparent',
    padding: 20,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 10,
  },
  related: {
    settings: ContainerSettings,
  },
  rules: {
    canDrag: () => true,
    canDrop: () => true,
    canMoveIn: () => true,
  },
};
